import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AuthGuard = () => {
  // Here, we're simply checking for a token in localStorage.
  // You may enhance this check to verify expiration, etc.
  const token = localStorage.getItem("token");

  // If no token, redirect to login.
  return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default AuthGuard;
